var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import global from './global';
import onboarding from './onboarding';
import errors from './errors';

export default _extends({}, global, onboarding, errors);


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/es-es/index.js